{
  "version": 1,
  "asset_id": "076d6f0a-4173-4050-a373-103ba4bb00ed",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/076d6f0a-4173-4050-a373-103ba4bb00ed/rv_living.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/076d6f0a-4173-4050-a373-103ba4bb00ed/rv_living.webp",
  "original_filename": "rv_living.webp",
  "size": 41860,
  "content_type": "image/webp",
  "created_at": "2026-07-14T02:53:32Z"
}
